<!-- Menu Trigger -->
<div #triggerRef [class]="triggerClass" (click)="trigger === 'click' ? toggle() : null"
    (mouseenter)="trigger === 'hover' ? open() : null" (mouseleave)="trigger === 'hover' ? startCloseTimer() : null"
    cdkOverlayOrigin #overlayOrigin="cdkOverlayOrigin">
    <ng-content select="[slot=trigger]"></ng-content>
</div>

<!-- Menu Template (rendered in overlay) -->
<ng-template #menuTemplate>
    <!-- Backdrop (rendered first, behind menu) -->
    @if (showBackdrop) {
    <div class="fixed inset-0 bg-black/20 backdrop-blur-sm -z-10" (click)="close()"></div>
    }

    <div [class]="computedMenuClasses()" (mouseenter)="trigger === 'hover' ? clearCloseTimer() : null"
        (mouseleave)="trigger === 'hover' ? close() : null" (click)="handleMenuClick($event)">
        <!-- Menu Items -->
        <div class="relative z-10 py-2">
            <!-- Custom content slot (takes priority if provided) -->
            <ng-content select="[slot=content]"></ng-content>

            <!-- Default menu items (only if no custom content and items exist) -->
            @if (!hasCustomContent && items.length > 0) { @for (item of items; track item.id || item.label) {
            <!-- Divider -->
            @if (item.divider) {
            <div class="h-px bg-blue-200/10 my-2 mx-4"></div>
            }

            <!-- Menu Item -->
            <div [class]="getItemClasses(item)" (click)="handleItemClick(item, $event)"
                [attr.aria-disabled]="item.disabled">
                <!-- Icon -->
                @if (item.icon) {
                <span class="shrink-0">
                    <ng-content [select]="'[slot=icon-' + item.icon + ']'"></ng-content>
                </span>
                }

                <!-- Label -->
                <span class="flex-1 truncate">{{ item.label }}</span>

                <!-- Submenu indicator -->
                @if (item.submenu && item.submenu.length > 0) {
                <svg class="ml-2 h-4 w-4 transform transition-transform group-hover:translate-x-0.5" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
                }

                <div class="absolute inset-x-3 top-0 h-px opacity-0 transition-opacity duration-200 group-hover:opacity-100 bg-linear-to-r from-transparent via-white/16 to-transparent"></div>
            </div>
            } }
        </div>

        <div class="absolute inset-0 rounded-[24px] opacity-60 -z-10">
            <div
                class="absolute inset-x-4 top-0 h-px bg-linear-to-r from-transparent via-blue-200/22 to-transparent">
            </div>
            <div
                class="absolute inset-x-5 bottom-0 h-px bg-linear-to-r from-transparent via-slate-200/10 to-transparent">
            </div>
        </div>
    </div>
</ng-template>
